import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { WorkspaceSliceDTO } from './types'

export const WORKSPACE_OPTION_FRAGMENT: TypedDocumentNode<WorkspaceSliceDTO> = gql`
  fragment WorkspaceOptionFragment on Workspace {
    id
    name
  }
`
